import React, { FC } from 'react';
import { Trans } from 'react-i18next';

import { SearchGroupsDocument } from 'api';
import { GroupsWidget, Queries } from 'components';
import { groups as groupsPath } from 'paths';

const RecommendedGroups: FC = () => (
  <Queries.Search
    loader="none"
    document={SearchGroupsDocument}
    variables={{ results_from: 0, size: 3, auto_exclude: true }}>
    {({ results }) => (
      <GroupsWidget
        maxResults={3}
        maxWidth={180}
        link={groupsPath}
        results={results}
        title={<Trans i18nKey="groups:recommendedGroups" />}
      />
    )}
  </Queries.Search>
);

export default RecommendedGroups;
